import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'filterData'
})
export class FilterDataPipe implements PipeTransform {

	transform(items: any[], filter: string): any {
		if (!items || !filter) {
			return items;
		}

		return items.filter(item => {
			item.role.toLowerCase().indexOf(filter.toLowerCase()) !== -1;
		});
	}

}
